/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_No_TasksInputs */

const en_dashboard_no_tasks = /** @type {(inputs: Dashboard_No_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no outstanding workflow tasks assigned to you. Enjoy your clean workspace!`)
};

const pt_br2_dashboard_no_tasks = /** @type {(inputs: Dashboard_No_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há atividades de fluxo atribuídas a você. Aproveite seu espaço limpo!`)
};

/**
* | output |
* | --- |
* | "There are no outstanding workflow tasks assigned to you. Enjoy your clean workspace!" |
*
* @param {Dashboard_No_TasksInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_no_tasks = /** @type {((inputs?: Dashboard_No_TasksInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_No_TasksInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_no_tasks(inputs)
	return pt_br2_dashboard_no_tasks(inputs)
});